import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7886c6f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "avatar" }

import {computed} from "vue";
	import { useGlobalStore } from '@/stores/GlobalStore'

	
export default /*#__PURE__*/_defineComponent({
  __name: 'Avatar',
  setup(__props) {

	const globalStore = useGlobalStore();
	const initials = computed(() =>  {
		const name = globalStore.user?.firstName +" "+globalStore.user?.lastName;
		return name.match(/(^\S\S?|\s\S)?/g).map(v=>v.trim()).join("").match(/(^\S|\S$)?/g).join("").toLocaleUpperCase();
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(initials.value), 1))
}
}

})